import { render, staticRenderFns } from "./NotificationTemplatesUpdate.vue?vue&type=template&id=02b86803"
import script from "./NotificationTemplatesUpdate.vue?vue&type=script&lang=js"
export * from "./NotificationTemplatesUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports